<template>
  <div class="home-page">
    <HomeContent />
    <Footer />
  </div>
</template>

<script>
import HomeContent from '../components/Home.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'HomePage',
  components: {
    HomeContent,
    Footer
  },
  mounted() {
    // 滚动吸附由 App.vue 按断点统一管理；滚动到顶部保证吸附位置正确；
    // iOS Safari 在 mounted 阶段 scrollTo 不可靠，需 $nextTick 确保 DOM 就绪后再执行
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
  }
}
</script>

<style scoped>
/* 首页页脚吸附方式与其他页面统一：底部对齐吸附，保证最后一屏完整展示 */
.home-page >>> .footer {
  scroll-snap-align: end;
}
</style>
